import { PropsWithChildren } from "react";
import c from "classnames";

import { Icon } from "@design-system/Icon/Icon";
import { Text } from "@design-system/Text/Text";

import classes from "./Callout.module.css";
import * as icons from "../Icon/icons";

type CalloutType = "info" | "success" | "warning" | "error";

interface Props {
  type?: CalloutType;
  title?: string;
  className?: string;
}

const typeIconMap: Record<CalloutType, keyof typeof icons> = {
  info: "faCircleInfo",
  success: "faCircleCheck",
  warning: "faCircleExclamation",
  error: "faCircleXmark",
};

export const Callout = ({
  type = "info",
  title,
  children,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <div className={c(classes.callout, classes[type], className)}>
      <div className={classes.iconContainer}>
        <Icon icon={typeIconMap[type]} size="lg" className={classes.icon} />
      </div>
      <div className={classes.content}>
        {title && (
          <div className={classes.title}>
            <Text weight={700} spacing="tight">
              {title}
            </Text>
          </div>
        )}
        <div className={classes.body}>
          {typeof children === "string" ? (
            <Text spacing="relaxed">{children}</Text>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};
